/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import { CNavGroup, CNavItem, CNavLink } from '@coreui/react-pro'
import { useHistory, useLocation } from 'react-router-dom'
import AppSidebarNavItemLink from './AppSidebarNavItemLink'
import { useAppDispatch, useTypedSelector } from '../../stateStore'
import {
  getSidebarMenu,
  getVendorSidebarMenu,
} from '../../middleware/api/SidebarMenu/sidebarMenuApi'
import { reduxServices } from '../../reducers/reduxServices'
import useMobilePort from '../../middleware/hooks/useMobilePort'
import { EmployeePolicyAgreementType } from '../../types/EmployeeHandbook/employeeHandbookTypes'
import {
  childmenuItems,
  SidebarMenuReturnApi,
} from '../../types/SidebarMenu/sidebarMenuType'
import { profileRoute } from '../../constant/constantData'
import useRouteHistory from '../../middleware/hooks/useRouteHistory'

const AppSidebarNavItems = (props: {
  setIsDisabled: (value: boolean) => void
}): JSX.Element => {
  const location = useLocation()
  const history = useHistory()
  const isMobile = useMobilePort()
  // const [isViewingAnotherEmployee] = useSelectedEmployee()
  const { route } = useRouteHistory()
  const employeeId: string | number = useTypedSelector(
    (state) => state.authentication.authenticatedUser.employeeId,
  )
  const reRenderMenu: boolean = useTypedSelector(
    (state) => state.app.reRenderMenu,
  )
  const dispatch = useAppDispatch()
  const getSidebarMenuItems = useTypedSelector(
    reduxServices.sidebarMenu.selectors.getSidebarMenuItems,
  )
  const sidebarShow = useTypedSelector(
    reduxServices.app.selectors.getSidebarShow,
  )
  const employeePolicyAgreementHistory = useTypedSelector(
    reduxServices.EmployeeHandbook.selectors.employeePolicyAgreementHistory,
  )
  const empInfoDataFlags = useTypedSelector(
    reduxServices.generalInformation.selectors.empMandatoryFlags,
  )

  const sortAgreeHistory: EmployeePolicyAgreementType = useMemo(() => {
    if (employeePolicyAgreementHistory.length > 0)
      return employeePolicyAgreementHistory[0]
    else return {} as EmployeePolicyAgreementType
  }, [employeePolicyAgreementHistory])

  const isVendor = localStorage.getItem('isVendor') === 'true'
  const [disableNavItem, setDisablenavItem] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 1000)
  }, [])

  useEffect(() => {
    if (reRenderMenu) {
      if (isVendor) {
        dispatch(getVendorSidebarMenu(employeeId))
      } else {
        dispatch(getSidebarMenu(employeeId))
      }

      dispatch(reduxServices.app.actions.setReRenderMenu(false))
    }
  }, [dispatch, employeeId, reRenderMenu])

  const onHovered = (name: string) => {
    if (sidebarShow) return
    const navGroups = document.querySelectorAll('.nav-group')
    navGroups.forEach((e) => {
      const span = e.querySelector('span')
      if (span?.id === name) {
        const popup = e.querySelector('.nav-group-items')
        if (popup) {
          e.classList.add('show')
          positionPopup(e)
        } else {
          e.classList.remove('show')
        }
      } else {
        e?.classList.remove('show')
      }
    })
  }

  const isElementBottomVisible = (element: any) => {
    const rect = element.getBoundingClientRect()
    return rect.bottom <= window.innerHeight
  }

  const positionPopup = (sidebarItem: any) => {
    let top: any
    let left: any
    const rect = sidebarItem.getBoundingClientRect()
    const popup = sidebarItem.querySelector('.nav-group-items')
    if (popup) {
      const test = isElementBottomVisible(popup)
      if (test) {
        const adjusted = sidebarItem.querySelector('.adjusted')
        if (adjusted) {
          const marginTopAdjustment = 0
          const calculatedTop = rect.bottom + marginTopAdjustment
          const adjustedTop = Math.min(
            calculatedTop,
            window.innerHeight - popup.clientHeight,
          )
          top = `${adjustedTop}px`
        } else {
          top = `${rect.bottom}px`
        }
        left = `${rect.right}px`
      } else {
        const marginTopAdjustment = -35
        const calculatedTop = rect.bottom + marginTopAdjustment
        const adjustedTop = Math.min(
          calculatedTop,
          window.innerHeight - popup.clientHeight,
        )
        top = `${adjustedTop}px`

        left = `${rect.right}px`
        popup.classList.add('adjusted')
      }
    }
    popup.style.top = top
    popup.style.left = left
  }

  useEffect(() => {
    const scrollEvent = () => {
      const navGroups = document.querySelectorAll('.nav-group')
      navGroups.forEach((e) => {
        e?.classList.remove('show')
      })
    }
    const beforeUnloadEvent = () => {
      window.scrollTo(0, 0)
    }
    window.addEventListener('load', beforeUnloadEvent)
    window.addEventListener('beforeunload', beforeUnloadEvent)
    window.addEventListener('scroll', scrollEvent)

    return () => {
      window.removeEventListener('scroll', scrollEvent)
      window.removeEventListener('beforeunload', beforeUnloadEvent)
      window.removeEventListener('load', beforeUnloadEvent)
    }
  }, [])

  useEffect(() => {
    const sortedAgreedHistoryCheck =
      sortAgreeHistory !== null &&
      // Will check if the user account is still handbook initial phase and has not yet agreed to any policy
      sortAgreeHistory?.id === null &&
      !sortAgreeHistory?.dashboardView &&
      sortAgreeHistory?.country

    const MandatoryFieldsFilled =
      empInfoDataFlags.basicInfoFlag &&
      empInfoDataFlags.employeeQualificationflag &&
      empInfoDataFlags.personalInfoFlag
    setDisablenavItem(
      !!sortedAgreedHistoryCheck ||
        (!MandatoryFieldsFilled && route === profileRoute),
    )
    props.setIsDisabled(
      !!(
        (sortAgreeHistory?.id === null && sortAgreeHistory?.country) ||
        (!MandatoryFieldsFilled && route === profileRoute)
      ),
    )
  }, [sortAgreeHistory, getSidebarMenuItems, empInfoDataFlags, route])

  function navLink(name: string, iconClass: string) {
    return (
      <>
        {iconClass && (
          <span
            className="nav-icon"
            onMouseEnter={() => onHovered(name)}
            id={name}
          >
            <i className={iconClass}></i>
          </span>
        )}
        {name}
      </>
    )
  }

  function childLink(name: string) {
    return (
      <>
        <span className="child-arrow"></span>
        {name}
      </>
    )
  }

  function linkClick() {
    dispatch(reduxServices.employeeList.actions.setStatusValue('Active'))
    if (isMobile) {
      dispatch(reduxServices.app.actions.toggleSidebar())
    }
  }

  const NavChildItemRenderer = (
    curNavItem: SidebarMenuReturnApi,
  ): JSX.Element => {
    if (sidebarShow) {
      return (
        <>
          {curNavItem.childmenuItems.map((curChildNavItem: childmenuItems) => (
            <CNavItem key={curChildNavItem.menuName}>
              <CNavLink
                className="child-link"
                onClick={() => {
                  if (curChildNavItem.menuUrl === 'employeeList') {
                    dispatch(reduxServices.app.actions.setSearchString(''))
                  } else {
                    dispatch(
                      reduxServices.employeeList.actions.setStatusValue(
                        'Active',
                      ),
                    )
                    // clear the selected item if move to another page
                    dispatch(
                      reduxServices.reviewList.actions.setSelectedItemID(''),
                    )
                  }

                  if (!disableNavItem) {
                    history.push(`/${curChildNavItem.menuUrl}`)
                  }
                }}
                disabled={disableNavItem}
              >
                {childLink(curChildNavItem.menuName)}
              </CNavLink>
            </CNavItem>
          ))}
        </>
      )
    } else {
      return (
        <>
          <li className="nav-item">
            <span className="mobile-child-link group-name">
              {curNavItem.menuName}
            </span>
          </li>
          {curNavItem.childmenuItems.map((curChildNavItem: childmenuItems) => (
            <AppSidebarNavItemLink
              key={curChildNavItem.menuName}
              url={curChildNavItem.menuUrl}
              name={curChildNavItem.menuName}
              disableNavItem={disableNavItem}
            />
          ))}
        </>
      )
    }
  }

  const filteredMenuItems = useMemo(() => {
    if (isVendor) {
      return getSidebarMenuItems?.filter(
        (item: SidebarMenuReturnApi) => item.menuName !== 'My Profile',
      )
    }
    return getSidebarMenuItems
  }, [getSidebarMenuItems, isVendor])

  return (
    <>
      {filteredMenuItems?.map(
        (curNavItem: SidebarMenuReturnApi, index: number) => {
          if (
            isVendor &&
            curNavItem.menuName === 'Recruitment' &&
            curNavItem.childmenuItems.length
          ) {
            return (
              <React.Fragment key={index}>
                {NavChildItemRenderer(curNavItem)}
              </React.Fragment>
            )
          }

          return curNavItem.childmenuItems.length ? (
            <CNavGroup
              idx={String(index)}
              key={index}
              toggler={navLink(curNavItem.menuName, curNavItem.menuclass)}
              visible={location.pathname.startsWith(curNavItem.menuurl)}
            >
              {NavChildItemRenderer(curNavItem)}
            </CNavGroup>
          ) : (
            <CNavItem key={index}>
              <CNavLink
                className="nav-link"
                onClick={() => {
                  if (!disableNavItem) {
                    history.push(`/${curNavItem.menuurl}`)
                  }
                  linkClick()
                }}
                disabled={disableNavItem}
              >
                {navLink(curNavItem.menuName, curNavItem.menuclass)}
              </CNavLink>
            </CNavItem>
          )
        },
      )}
    </>
  )
}

export default AppSidebarNavItems
